import Vuei18n from '@/translations';

async function getAmountBusiness() {
  const responsePromise = await fetch('/businessAmount.json');

  const response = await responsePromise.json();
  const formattedData = response.map(item => ({
    x: item.label,
    y: item.amount,
  }));

  return [
    {
      name: Vuei18n.t('business'),
      data: formattedData,
    },
  ];
}

export default getAmountBusiness;
